import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { injectIntl } from 'react-intl';

import { black5 } from '../../../assets/shared-styles/general';
import { getUnassignedMembersInDepartment } from '../../Admin/DepartmentsPage/DepartmentsPage.data';
import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import EcMultipleSelectValue from '../../Shared/EcMultipleSelectValue/EcMultipleSelectValue';
import EcMultiSelect from '../../Shared/EcMultiSelect/EcMultiSelect';
import LoadingSpinner from '../../Shared/Icons/LoadingSpinner';
import SubArrowIcon from '../../Shared/Icons/SubArrowIcon';
import styles from './DepartmentMembersModal.styles';

class DepartmentMembersModal extends Component {
  constructor(props) {
    super(props);

    this.handleOnSaveClick = this.handleOnSaveClick.bind(this);

    this.state = {
      loading: false,
      editData: {
        members: [],
      },
    };
  }

  componentDidMount() {
    const { clientId, departmentId } = this.props;

    this.setState({ loading: true });
    getUnassignedMembersInDepartment(clientId, departmentId)
      .then((data) => {
        if (data) {
          const members = data.map((member) => {
            return {
              label: `${member.full_name}`,
              value: `${member.full_name}`,
              id: member.id,
            };
          });
          this.setState({ loading: false, members });
        }
      })
      .catch(() => this.setState({ loading: false, errorLoading: true }));
  }

  handleOnSaveClick() {
    const { handleActionClick, hideModal } = this.props;
    const {
      editData: { members },
    } = this.state;
    const memberIds = members.length ? members.map((member) => member.id) : [];
    if (memberIds) {
      handleActionClick(memberIds);
    }
    hideModal();
  }

  renderMultiSelectMenu() {
    const defaultItems = this.state.members;
    const presentValue = this.state.editData['members'];

    return (
      <div>
        <EcMultiSelect
          value={presentValue}
          options={defaultItems}
          onChange={(newItems) => {
            const newState = {};
            newState['members'] = newItems;
            this.setState({
              editData: { ...this.state.editData, ...newState },
            });
          }}
          noOptionsMessage={this.props.intl.formatMessage({
            id: 'DepartmentMembersModal.noUsersFound',
            defaultMessage: 'No users found',
            description: 'Message when no users are found in search',
          })}
          placeholder={this.props.intl.formatMessage({
            id: 'DepartmentMembersModal.enterUsersPlaceholder',
            defaultMessage: 'Enter users...',
            description: 'Placeholder text for user search input',
          })}
          openMenuOnClick={true}
        />
        {this.renderItemValues()}
      </div>
    );
  }

  renderItemValues() {
    const { classes } = this.props;
    const presentValues = this.state.editData['members'];

    return (
      <div
        className={classes.multipleValuesContainer}
        data-testid="department-add-users-modal"
      >
        <SubArrowIcon color={black5} />
        <div className={classes.multipleValues}>
          {presentValues.length ? (
            presentValues.map((value) => (
              <EcMultipleSelectValue
                label={value.label}
                key={value.value}
                closeHandler={() => {
                  const newState = {};
                  const newMultiState = [...this.state.editData['members']];
                  newState['members'] = newMultiState.filter(
                    (multiValue) => multiValue.value !== value.value,
                  );
                  this.setState({
                    editData: { ...this.state.editData, ...newState },
                  });
                }}
              />
            ))
          ) : (
            <span className={classes.multipleValuesEmpty}>
              {this.props.intl.formatMessage({
                id: 'DepartmentMembersModal.noValuesSelected',
                defaultMessage: 'No values selected...',
                description: 'Message when no users are selected',
              })}
            </span>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { classes, title, hideModal } = this.props;
    const {
      loading,
      editData: { members },
      errorLoading,
    } = this.state;

    if (loading && !errorLoading) {
      return (
        <div className={classes.loadingContainer}>
          <LoadingSpinner size="medium" />
        </div>
      );
    } else if (!loading && errorLoading) {
      return (
        <div className={classes.errorMessage}>
          {this.props.intl.formatMessage({
            id: 'DepartmentMembersModal.errorLoadingUsers',
            defaultMessage: 'An error occurred while loading the users.',
            description: 'Error message when users fail to load',
          })}
        </div>
      );
    }
    return (
      <EcModalCard
        title={title}
        content={this.renderMultiSelectMenu()}
        footer={
          <>
            <Button
              variant="tertiary"
              onClick={hideModal}
              text={this.props.intl.formatMessage({
                id: 'DepartmentMembersModal.cancelButton',
                defaultMessage: 'Cancel',
                description: 'Cancel button text',
              })}
            />
            <Button
              variant="primary"
              tooltip={this.props.intl.formatMessage({
                id: 'DepartmentMembersModal.addUsersTooltip',
                defaultMessage: 'Add Users',
                description: 'Tooltip for add users button',
              })}
              disabled={!members.length}
              text={this.props.intl.formatMessage({
                id: 'DepartmentMembersModal.addUsersButton',
                defaultMessage: 'Add Users',
                description: 'Add users button text',
              })}
              onClick={this.handleOnSaveClick}
            />
          </>
        }
        hideModal={hideModal}
      />
    );
  }
}

DepartmentMembersModal.propTypes = {
  title: PropTypes.string.isRequired,
  handleActionClick: PropTypes.func.isRequired,
  hideModal: PropTypes.func,
};

export default injectSheet(styles)(injectIntl(DepartmentMembersModal));
